import { takeEvery, put, all, fork, select } from 'redux-saga/effects';
import { GET_PRIVACY, actionCreators } from './action';

import privacy_policy_PL from '../../translations/pl_PL/blog/privacy-policy.json';
import privacy_policy_EN from '../../translations/en_GB/blog/privacy-policy.json';

const privacyPolicy = {
  'en_GB': privacy_policy_EN, 
  'pl_PL': privacy_policy_PL
}
function* onGetPrivacySaga() {
    try {

      const language = yield select((state) => state.language);

      // call to api
      // const response = yield call(fetch, 'http://localhost:8080/privacy-policy');
      // const privacyData = yield response.json();
      // put response to store
      // yield put(actionCreatorsPrivacy.putPrivacy(privacyData));
      yield put(actionCreators.putPrivacy(privacyPolicy[language]));
    }
    catch(error) {
      // yield put(actionCreators.putAgreement(null));
    }
  }

function* getPrivacySaga() {
	yield takeEvery(GET_PRIVACY, onGetPrivacySaga);
}

export function* privacySaga() {
	yield all([fork(getPrivacySaga)]);
}